import { app } from "@microsoft/teams-js";

export let isTeamsRuntime = null;
export let isTeamsRuntimeAsync = null;

async function canInit() {
    isTeamsRuntimeAsync = Promise.race([
        new Promise((resolve, reject) => setTimeout(reject, 200)),
        app.initialize()
    ]).then(() => true).catch(() => false);
    isTeamsRuntime = await isTeamsRuntimeAsync;
}
canInit();
